<div class="change-country-notice" *ngIf="showChangeCountryNotice">
  <div class="d-flex justify-content-center change-country-notice-content">
    <div class="d-flex align-items-center justify-content-center">
      <span>Change to {{ISOCountryCode[countryCodeToChange]}} site to see content specific to your location.</span>
      <button class="btn btn-border mr-2 ml-4" (click)="onDismissChangeCountryNotice()">No, Thanks</button>
      <button class="btn btn-yes mr-2" (click)="onChangeCountrySite()">Yes</button>
    </div>
    <div class="d-flex align-items-center justify-content-end">
    </div>
  </div>
</div>
<ng-container *ngIf="hideAppBase; else elseTemplate">
  <router-outlet></router-outlet>
</ng-container>
<ng-template #elseTemplate>
  <app-base *ngIf="!isMobileDetected && !hideAppBase">
    <app-base-inner>
      <router-outlet></router-outlet>
      <app-widget [widgetData]="widget" [closeWidgetCount]="CloseWidgetCounter" (closeWidgetCountChange)="setCloseWidgetCounter($event)"></app-widget>
    </app-base-inner>
    <app-dynamic-footer [hidden]="isLandingRoute || maintenanceDateTime !== null"></app-dynamic-footer>
  </app-base>
</ng-template>
<app-popup-announcement *ngIf="announcements$.length > 0" [message]="announcements$"
  (confirmed)="onUpdateAnnouncement()"></app-popup-announcement>
<app-request-receipt *ngIf="(isLoggedIn$ | async) === true"></app-request-receipt>
<app-floating-reward *ngIf="(isLoggedIn$ | async) === true"></app-floating-reward>